module.exports = __webpack_public_path__ + "static/media/ISCI_RTS1.5b1b332b.jpg";